export enum TableColumnAlign {
    Left, Center, Right
}
